import * as React from 'react';
import { SingleOptionPanel } from './options-panel/single-option-panel';
import { PanelsProps } from './types';
import { sfNames, sfParameters } from 'app/components/access-panel/sf-names';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';
import { ExtraFooterButton } from 'ui/common/select/types';

interface ExperienceTransferAlertsProps extends PanelsProps {
  extraFooterButton?: ExtraFooterButton;
}

export const ExperienceTransferAlerts = (props: ExperienceTransferAlertsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation,
    fetchingRoleBasedData, accessData, clearValueInStore, clearValidation, updateAccessData,
    extraFooterButton } = props;

  return <AdminPaperTopPanel title={translation.subscriber_groups}>
    <SingleOptionPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data?.experienceTransferAlerts}
      accessData={accessData?.experienceTransferAlerts}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}
      formComponent={formComponent}
      formValues={formValues}
      valueName={sfParameters.id}
      formName={sfNames.experienceTransferAlerts}
      validation={validation?.[sfNames.experienceTransferAlerts]}
      valueOptionsEndpoint={endpoints.subscriptionOptions}
      valueOptionsParams={{ includeDisabled: false }}
      valueLabel={translation.subscriber_groups_expander_title}
      panelLabel={translation.subscriber_groups_card_title}
      addButtonText={translation.add_subscriber_groups}
      displaySelectAll={true}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
      extraFooterButton={extraFooterButton} />
  </AdminPaperTopPanel>;
};
